<template>
    <div class="form-signup-project" v-if="form != null" :class="{'open' : options[0].index === openFormSignUpProject}">
        <div class="quality-form-title">
            <h2>{{form.form_signup_project_title}}</h2>
            <!-- {{options[0].index}} -->
            <a href="#" @click.prevent="closeForm" class="close-form-link">
                <svg-icon icon-class="close" className="share-icon icon-close"/>
            </a>
        </div>
        <form class="form_call">
            <div class="form-in" :class="{fadeOut : !formVisible}" v-if="formVisible">
                <div class="form-group form-text">
                    <label for="name">{{form.name_label}}</label>
                    <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                </div>
                <div class="form-group form-phone">
                    <label for="phone">{{form.phone_label}}</label>
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.phone_mask" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                </div>
                <div class="form-group form-mail">
                    <label for="email">{{form.email_label}}</label>
                    <input type="text" name="email" class="form-control"  :placeholder="form.email_mask" v-model="mail" v-validate="{rules: { required: true, regex: regexRules.mail }}"  data-vv-delay="1000">
                </div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.send_signup_btn_desc}}</button>
                    <span class="error-message" v-show="errors.has('name') || errors.has('phone') || errors.has('email')">Заполните все поля</span>
                </div>
            </div>
            <div class="successMessage" v-if="!formVisible">
                <h3>Спасибо, ваши контакты внесены в базу потенциальных клиентов. Ожидайте старта продаж!</h3>
            </div>
        </form>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import { Validator } from 'vee-validate';
    export default {
        name: 'FormSignUpProject',
        props: ['options'],
        data () {
            return {
                phone: '',
                name: '',
                mail: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            MaskedInput,
        },
        computed: mapGetters({
            form: 'loadForms',
            openFormSignUpProject: 'loadOpenFormSignUpProject',
            formData: 'loadFormConsultData',
            currentCityArr: 'loadCurrentCityArr',
        }),
        methods: {
            sendData() {
                var querystring = require('querystring');
                var data = {
                    'admin': this.form.email_admin,
                    'name': this.name,
                    'phone': this.phone,
                    'mail': this.mail,
                    'city': this.currentCityArr[0].region,
                    'page': 'Жилые комплексы',
                    'page_key': 'sales',
                    'project_name': this.options[0].project_name,
                };
                console.log(data, 'form project signup')
                // console.log(JSON.stringify(data));
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        axios.post('/formSignUpProject.php', querystring.stringify(data));
                        $.ajax({
                            url: "https://docs.google.com/forms/d/e/1FAIpQLSfLfqJtcLIxiry8bQuQnpsu7YkGVaw5vH7W-tiB3pdBXb1w3A/formResponse",
                            data: {
                                // project_name
                                "entry.1332650377": this.options[0].project_name,
                                // name
                                "entry.843503799": this.name,
                                // phone
                                "entry.1832553192": this.phone,
                                // email
                                "entry.1927270287": this.mail,
                                // city
                                "entry.63198146": this.currentCityArr[0].region,
                            },
                            type: "POST",
                            dataType: "xml"
                        });
                        setTimeout(() => {
                            this.closeForm();
                        }, 1200);
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            closeForm() {
                this.$store.commit('Open_form_SignUp_Project', false);
                this.phone = '';
                this.name = '';
                this.mail = '';
                setTimeout(() => {
                    this.formVisible = true;
                }, 600);
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.forms,
            //     (newValue) => {
            //         if (newValue)
            //         this.admin_mail = this.form.admin_email
            //     }
            // )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-signup-project.scss';
    // @import '@/styles/respond/forms/form-consult-respond.scss';
</style>